import { render, staticRenderFns } from "./AppPopularCategories.vue?vue&type=template&id=b3b0f72c&scoped=true&"
import script from "./AppPopularCategories.vue?vue&type=script&lang=js&"
export * from "./AppPopularCategories.vue?vue&type=script&lang=js&"
import style0 from "./AppPopularCategories.vue?vue&type=style&index=0&id=b3b0f72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b0f72c",
  null
  
)

export default component.exports